import { IFormConfigQualifierAttribute } from "../../service/formconfiguration/FormConfigQualifierAttribute";
import { IQualiferService } from "../../service/formconfiguration/QualifierService";

export default class UpdateFormConfigQualifierAttributeInteractor {
  private qualifierService: IQualiferService;

  constructor(qualifierService) {
    this.qualifierService = qualifierService;
  }

  async execute(
    qualifierCode: string,
    attributeCode: string,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ) {
    await this.qualifierService.updateFormConfigQualifierAttribute(
      qualifierCode,
      attributeCode,
      formConfigQualifierAttribute
    );
  }
}
